export default function () {
  let window = `relatorio.leiloes.pagamentos`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Relação de Pagamentos Efetuados do Leilão',
    width: '600',
    height: '400',
    minHeight: '400px',
    backdrop: false,
    maximize: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
    }
  }, () => import('./AnalisePagamentosLeilao.vue'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
